import '../../phito-core/src/lib/components/phito-text-editor/quill-init';

import { provideAppInitializer, inject, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { AppConfigService } from '../../phito-core/src/lib/services/app-config.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PhitoSecurityInterceptor } from '../../phito-core/src/lib/services/backend-api.interceptor';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { PhitoDateAdapter, PHITO_DATE_FORMATS } from '../../phito-core/src/lib/adapters/phito-date-adapter';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PhitoMatPaginator } from '../../phito-core/src/lib/adapters/phito-paginator-adapter';
import {
    TERMINAL_LOGIN_ACTIVE,
    CUSTOM_LOGO_LOGIN,
    PHITO_AUTOCOMPLETE_ITEMS_LIMIT, REGISTRATION_ACTIVE,
    APP_NAME,
} from '../../phito-core/src/lib/phito-core.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter, TitleStrategy } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { AuthGuard } from '../../phito-core/src/lib/app/app/app.auth-guard';
import { PhitoTitleStrategy } from '../../phito-core/src/lib/app/app/phito-title-strategy';

registerLocaleData(localeDe);

const formFieldAppearance: MatFormFieldDefaultOptions = { appearance: 'outline' };

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideAppInitializer(() => {
            const configService = inject(AppConfigService);
            return configService.loadConfig();
        }),
        provideRouter(appRoutes),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: PhitoSecurityInterceptor, multi: true },
        AuthGuard,
        { provide: LOCALE_ID, useValue: 'de' },
        { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
        { provide: 'APP_PREFIX', useValue: 'schule' },
        { provide: DateAdapter, useClass: PhitoDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: PHITO_DATE_FORMATS },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: formFieldAppearance },
        { provide: MatPaginatorIntl, useClass: PhitoMatPaginator },
        { provide: TERMINAL_LOGIN_ACTIVE, useValue: false },
        { provide: REGISTRATION_ACTIVE, useValue: false },
        { provide: CUSTOM_LOGO_LOGIN, useValue: undefined },
        { provide: PHITO_AUTOCOMPLETE_ITEMS_LIMIT, useValue: 25 },
        { provide: APP_NAME, useValue: 'phito. Gefährdungsbeurteilung' },
        { provide: TitleStrategy, useClass: PhitoTitleStrategy },
        DatePipe,
    ],
}).catch((err) => console.error(err));
